import { render, staticRenderFns } from "./BrandIndex.vue?vue&type=template&id=47c18191"
import script from "./BrandIndex.vue?vue&type=script&lang=js"
export * from "./BrandIndex.vue?vue&type=script&lang=js"
import style0 from "./BrandIndex.vue?vue&type=style&index=0&id=47c18191&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports